// SEO metadata for all pages
export const seoData = {
  "/": {
    title: "WellTec | Locação e Manutenção de Lavadoras de Piso em BH",
    description: "Locação e manutenção de lavadoras e varredeiras de piso em BH, Contagem e Mário Campos. Assistência técnica, peças originais e suporte. (31) 97182-3249",
    canonical: "https://www.wellttec.com/"
  },
  "/servicos": {
    title: "Manutenção de Lavadora e Varredeira de Piso | WellTec",
    description: "Manutenção preventiva e corretiva, reforma completa, peças e equipamentos revisados para lavadoras e varredeiras de piso em BH e região.",
    canonical: "https://www.wellttec.com/servicos"
  },
  "/locacao-lavadora-piso": {
    title: "Locação de Lavadora de Piso em BH | Manutenção Inclusa",
    description: "Aluguel mensal de lavadoras e varredeiras industriais com manutenção inclusa, equipamento reserva e suporte técnico em BH e região.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso"
  },
  "/limpeza-pos-obra": {
    title: "Limpeza Pós-Obra em BH e Região Metropolitana | WellTec",
    description: "A WellTec oferece soluções de limpeza mecanizada pós-obra para galpões, indústrias, condomínios e áreas comerciais em BH e região metropolitana. Solicite um orçamento.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra"
  },
  "/blog": {
    title: "Blog WellTec | Limpeza Pós-Obra e Equipamentos Industriais",
    description: "Confira dicas sobre limpeza pós-obra, lavadoras e varredeiras de piso, manutenção de equipamentos e soluções para limpeza industrial da WellTec em BH e região.",
    canonical: "https://www.wellttec.com/blog"
  },
  "/equipamentos-disponiveis": {
    title: "Equipamentos para Locação | Lavadoras e Varredeiras | WellTec",
    description: "Conheça as lavadoras e varredeiras de piso disponíveis para locação na WellTec. Consulte especificações técnicas, folhetos e solicite um orçamento.",
    canonical: "https://www.wellttec.com/equipamentos-disponiveis"
  },
  "/blog/custo-limpeza-pos-obra": {
    title: "Quanto Custa Limpeza Pós-Obra em BH? Preços por m²",
    description: "Veja o que influencia o preço da limpeza pós-obra em BH, valores médios por m² e como pedir um orçamento realista.",
    canonical: "https://www.wellttec.com/blog/custo-limpeza-pos-obra"
  },
  "/reforma-tennant-m20": {
    title: "Reforma de Lavadora Tennant M20 em BH | WellTec",
    description: "Reforma completa e manutenção de lavadoras Tennant M20. Peças originais, revisão geral e garantia. Atendemos BH e região.",
    canonical: "https://www.wellttec.com/reforma-tennant-m20"
  },
  "/reforma-tennant-a5": {
    title: "Reforma de Lavadora Tennant A5 em BH | WellTec",
    description: "Reforma completa de lavadoras Tennant A5 com peças originais, revisão técnica especializada e garantia. Serviço em BH e região metropolitana.",
    canonical: "https://www.wellttec.com/reforma-tennant-a5"
  },
  "/faq-locacao-lavadora-piso": {
    title: "Perguntas Frequentes sobre Locação de Lavadora | WellTec",
    description: "Tire suas dúvidas sobre locação de lavadoras de piso: valores, manutenção, contratos, prazos e equipamentos disponíveis em BH.",
    canonical: "https://www.wellttec.com/faq-locacao-lavadora-piso"
  },
  "/locacao-lavadora-piso-belo-horizonte": {
    title: "Locação de Lavadora de Piso em Belo Horizonte | WellTec",
    description: "Aluguel de lavadoras industriais em BH com manutenção inclusa. Atendimento em todos os bairros da capital mineira.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-belo-horizonte"
  },
  "/locacao-lavadora-piso-contagem": {
    title: "Locação de Lavadora de Piso em Contagem MG | WellTec",
    description: "Locação de lavadoras industriais em Contagem com foco no polo industrial. Manutenção inclusa e suporte 24h para CDI.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-contagem"
  },
  "/locacao-lavadora-piso-betim": {
    title: "Locação de Lavadora de Piso em Betim MG | WellTec",
    description: "Aluguel de lavadoras para fornecedores automotivos em Betim. Expertise em JIT e operação industrial 24h.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-betim"
  },
  "/locacao-lavadora-piso-nova-lima": {
    title: "Locação de Lavadora de Piso em Nova Lima | WellTec",
    description: "Locação premium de lavadoras silenciosas para condomínios e empresas em Nova Lima. Atendimento VIP em Vila da Serra e Alphaville.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-nova-lima"
  },
  "/locacao-lavadora-piso-minas-gerais": {
    title: "Locação de Lavadora de Piso em Minas Gerais | WellTec",
    description: "Aluguel de lavadoras industriais em todo estado de Minas Gerais. Cobertura estadual com suporte regional.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-minas-gerais"
  },
  "/locacao-lavadora-piso-hospital": {
    title: "Locação de Lavadora de Piso para Hospitais | WellTec",
    description: "Lavadoras silenciosas e sanitizadas para hospitais e clínicas. Protocolos de higiene hospitalar e manutenção programada.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-hospital"
  },
  "/locacao-lavadora-piso-supermercado": {
    title: "Locação de Lavadora para Supermercados | WellTec",
    description: "Lavadoras de alta produtividade para supermercados. Limpeza noturna sem interferir na operação. Atendimento em BH e região.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-supermercado"
  },
  "/locacao-lavadora-piso-condominio": {
    title: "Locação de Lavadora para Condomínios | WellTec",
    description: "Lavadoras silenciosas para condomínios residenciais e comerciais. Equipamentos modernos e atendimento discreto em BH.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-condominio"
  },
  "/locacao-lavadora-piso-industria": {
    title: "Locação de Lavadora para Indústrias | WellTec",
    description: "Lavadoras industriais de alta capacidade para fábricas. Suporte 24h e manutenção que não para a produção.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-industria"
  },
  "/locacao-lavadora-piso-shopping": {
    title: "Locação de Lavadora para Shopping Centers | WellTec",
    description: "Lavadoras tripuladas para shoppings. Limpeza noturna de grandes áreas com backup garantido. Atendimento prioritário.",
    canonical: "https://www.wellttec.com/locacao-lavadora-piso-shopping"
  },
  "/limpeza-pos-obra-belo-horizonte": {
    title: "Limpeza Pós-Obra em Belo Horizonte | WellTec",
    description: "Limpeza pós-obra mecanizada em BH. Atendemos residências, condomínios, lojas e obras comerciais na capital.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-belo-horizonte"
  },
  "/limpeza-pos-obra-contagem": {
    title: "Limpeza Pós-Obra em Contagem MG | WellTec",
    description: "Limpeza pós-obra industrial em Contagem. Especialistas em grandes áreas fabris, galpões e centros de distribuição.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-contagem"
  },
  "/limpeza-pos-obra-betim": {
    title: "Limpeza Pós-Obra em Betim MG | WellTec",
    description: "Limpeza pós-obra para indústrias automotivas em Betim. Experiência com fornecedores Fiat e grandes plantas industriais.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-betim"
  },
  "/limpeza-pos-obra-nova-lima": {
    title: "Limpeza Pós-Obra em Nova Lima MG | WellTec",
    description: "Limpeza pós-obra premium em Nova Lima. Condomínios de alto padrão, empresas e empreendimentos comerciais.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-nova-lima"
  },
  "/limpeza-pos-obra-mario-campos": {
    title: "Limpeza Pós-Obra em Mário Campos MG | WellTec",
    description: "Limpeza pós-obra mecanizada em Mário Campos. Atendimento local rápido para obras residenciais e comerciais.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-mario-campos"
  },
  "/limpeza-pos-obra-galpoes": {
    title: "Limpeza Pós-Obra para Galpões Industriais | WellTec",
    description: "Limpeza pós-obra especializada em galpões industriais e logísticos. Equipamentos de alta capacidade para grandes áreas.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-galpoes"
  },
  "/limpeza-pos-obra-industrial": {
    title: "Limpeza Pós-Obra Industrial | WellTec",
    description: "Limpeza pós-obra para plantas industriais e fábricas. Remoção de resíduos de construção com equipamentos profissionais.",
    canonical: "https://www.wellttec.com/limpeza-pos-obra-industrial"
  },
  "/limpeza-piso-pos-obra": {
    title: "Limpeza de Piso Pós-Obra | Remoção de Cimento | WellTec",
    description: "Limpeza especializada de pisos pós-obra. Remoção de cimento, rejunte, argamassa e polimento de pisos industriais.",
    canonical: "https://www.wellttec.com/limpeza-piso-pos-obra"
  },
  "/blog/limpeza-pos-obra-residencial": {
    title: "Limpeza Pós-Obra Residencial: Guia Completo | WellTec",
    description: "Guia completo sobre limpeza pós-obra residencial. Etapas, cuidados e como contratar serviço profissional em BH.",
    canonical: "https://www.wellttec.com/blog/limpeza-pos-obra-residencial"
  },
  "/blog/limpeza-galpao-industrial": {
    title: "Como Limpar Galpão Industrial Corretamente | WellTec",
    description: "Melhores práticas para limpeza de galpões industriais. Equipamentos, frequência e técnicas profissionais.",
    canonical: "https://www.wellttec.com/blog/limpeza-galpao-industrial"
  },
  "/blog/limpeza-vs-convencional": {
    title: "Limpeza Mecanizada vs Manual: Qual Escolher? | WellTec",
    description: "Comparativo entre limpeza mecanizada e convencional. Custo-benefício, produtividade e quando usar cada método.",
    canonical: "https://www.wellttec.com/blog/limpeza-vs-convencional"
  },
  "/blog/remover-cimento-argamassa": {
    title: "Como Remover Cimento e Argamassa do Piso | WellTec",
    description: "Técnicas profissionais para remover cimento, rejunte e argamassa de pisos. Produtos e equipamentos recomendados.",
    canonical: "https://www.wellttec.com/blog/remover-cimento-argamassa"
  },
  "/blog/limpeza-condominios": {
    title: "Limpeza de Condomínios: Guia para Síndicos | WellTec",
    description: "Guia completo de limpeza para condomínios. Equipamentos, frequência, contratos e custos para áreas comuns.",
    canonical: "https://www.wellttec.com/blog/limpeza-condominios"
  },
  "/blog/equipamentos-limpeza-pos-obra": {
    title: "Equipamentos para Limpeza Pós-Obra Profissional | WellTec",
    description: "Conheça os equipamentos profissionais para limpeza pós-obra. Lavadoras, varredeiras e acessórios especializados.",
    canonical: "https://www.wellttec.com/blog/equipamentos-limpeza-pos-obra"
  },
  "/blog/limpeza-comercial": {
    title: "Limpeza Comercial: Melhores Práticas | WellTec",
    description: "Melhores práticas de limpeza para estabelecimentos comerciais. Frequência, equipamentos e padrões de qualidade.",
    canonical: "https://www.wellttec.com/blog/limpeza-comercial"
  },
  "/blog/tempo-limpeza-pos-obra": {
    title: "Quanto Tempo Leva uma Limpeza Pós-Obra? | WellTec",
    description: "Entenda os prazos de limpeza pós-obra conforme tamanho e tipo de obra. Planejamento e cronograma realista.",
    canonical: "https://www.wellttec.com/blog/tempo-limpeza-pos-obra"
  },
  "/blog/erros-construtoras": {
    title: "Erros Comuns de Construtoras na Limpeza Final | WellTec",
    description: "Erros frequentes de construtoras na limpeza pós-obra e como evitá-los. Checklist para entrega de obra limpa.",
    canonical: "https://www.wellttec.com/blog/erros-construtoras"
  }
};

export default seoData;
